<template>
  <v-container>
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      class="px-5 py-3 my-12"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            color="primary"
            fixed
            bottom
            left
            v-on="on"
            @click="$router.push(`/`)"
          >
            <v-icon>mdi-puzzle</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("works.modulesbtn") }}</span>
      </v-tooltip>
      <template v-slot:after-heading>
        <div class=" title text-no-wrap font-weight-bold">
          {{ $t("works.worksModule") }}
        </div>
      </template>
      <v-row>
        <template v-if="works">
          <v-col cols="12" lg="6">
            <base-material-card
              id="multiple-bar"
              color="success"
              icon="mdi-poll-box"
              class="px-4 py-3 my-4"
            >
              <template v-slot:after-heading>
                <div class="display-1 mt-2 font-weight-light">
                  {{ $t("works.gbpt") }}
                </div>
              </template>
              <apexchart
                type="bar"
                :options="optionsBars"
                :series="seriesBars"
              ></apexchart>
            </base-material-card>
          </v-col>
          <v-col cols="12" lg="6">
            <base-material-card
              id="multiple-bar"
              color="success"
              icon="mdi-poll-box"
              class="px-4 py-3 my-4"
            >
              <template v-slot:after-heading>
                <div class="display-1 mt-2 font-weight-light">
                  {{ $t("works.budgetDistribution") }}
                </div>
              </template>

              <apexchart
                with="100%"
                type="donut"
                height="400"
                :options="optionsPie"
                :series="seriesPie"
              ></apexchart>
            </base-material-card>
          </v-col>
        </template>
      </v-row>
    </base-material-card>
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      class="px-5 py-3 my-12"
    >
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            absolute
            top
            right
            color="primary"
            dark
            class=""
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.name"
                    :label="$t('works.name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.whoSent"
                    :label="$t('works.whoSent')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.whoReceive"
                    :label="$t('works.whoReceive')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.location"
                    :label="$t('works.location')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.description"
                    :label="$t('works.description')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="editedItem.dueDate"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.dueDate"
                        :label="$t('works.dueDate')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.dueDate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        {{ $t("works.cancel") }}
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(editedItem.dueDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
              {{ $t("works.cancel") }}
            </v-btn>
            <v-btn color="primary" @click="save">
              {{ $t("works.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :headers="headers"
        :items="works"
        sort-by="location"
        :search="search"
        class="elevation-0"
        :footer-props="{
          itemsPerPageText: $t('repairList.itemsPerPage'),
          itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
        }"
      >
        <template v-slot:top>
          <v-toolbar flat class="my-4" color="transparent">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('works.search')"
              single-line
              hide-details
            ></v-text-field>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this item?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ item.date | formatDate(user.language) | capitalize }}
        </template>
        <template v-slot:[`item.dueDate`]="{ item }">
          {{ item.dueDate | formatDate(user.language) | capitalize }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="goToItem(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      modal: false,
      dialogDelete: false,
      search: "",
      headers: [
        {
          text: this.$t("works.orderId"),
          align: "start",
          sortable: false,
          value: "id"
        },
        { text: this.$t("works.name"), value: "name" },
        { text: this.$t("works.location"), value: "location" },
        { text: this.$t("works.dateCreated"), value: "date" },
        { text: this.$t("works.dueDate"), value: "dueDate" },
        { text: this.$t("works.whoReceive"), value: "whoReceive" },
        { text: this.$t("works.whoSent"), value: "whoSent" },
        { text: "", value: "actions", sortable: false }
      ],
      headersStruc: [
        { text: "Nombre", sortable: true, value: "name" },
        { text: "Tipo", sortable: true, value: "type" },
        { text: "Fecha de Creación", value: "date" },
        { text: "Fecha Limite", value: "dueDate" },
        { text: "Ubicación Técnica", sortable: true, value: "location" },
        { text: "", value: "actions", sortable: false }
      ],

      editedIndex: -1,
      editedItem: {
        name: "",
        location: "",
        description: "",
        whoReceive: "",
        whoSent: "",
        dueDate: ""
      },
      defaultItem: {
        name: "",
        location: "",
        description: "",
        whoReceive: "",
        whoSent: "",
        dueDate: ""
      }
    };
  },

  computed: {
    ...mapState("works", ["works"]),
    ...mapState("auth", ["user"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    optionsBars() {
      return {
        chart: {
          height: 500,
          background: this.$vuetify.theme.dark ? "#1E1E1E" : "#FFFFFF",
          type: "bar",
          stacked: true
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light"
        },
        plotOptions: {
          bar: {
            columnWidth: "20%"
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label"
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0,
            formatter: val => {
              return this.formatMoney(val);
            }
          }
        },
        xaxis: {
          categories: this.works?.map(item => item.name),
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        }
      };
    },
    seriesBars() {
      return this.calcBars();
    },
    optionsPie() {
      return {
        chart: {
          background: this.$vuetify.theme.dark ? "#1E1E1E" : "#FFFFFF",
          type: "donut"
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  formatter: w => {
                    return this.formatMoney(
                      w.globals.seriesTotals.reduce((a, b) => {
                        return a + b;
                      }, 0)
                    );
                  }
                },
                value: { formatter: val => this.formatMoney(val) }
              }
            }
          }
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light"
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40
        },
        labels: this.works?.map(item => item.name),
        tooltip: {
          y: {
            show: true,
            formatter: val => this.formatMoney(val)
          }
        }
      };
    },
    seriesPie() {
      let series = this.works.map(work => {
        let budget = 0;
        work.inventory.map(elem => {
          budget += elem.partialCost * elem.quanty;
        });
        return budget;
      });
      return series;
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  async created() {
    await this.$store.dispatch("works/bindWorks");
  },
  methods: {
    calcBars() {
      let seriesAllData = [];
      let typesList = [];
      this.works?.map(work => {
        let listTypes = {};
        work.inventory?.map(elem => {
          if (!typesList.includes(elem.type)) typesList.push(elem.type);
          if (listTypes[elem.type]) {
            listTypes[elem.type] += +elem.partialCost * +elem.quanty;
          } else {
            listTypes[elem.type] = +elem.partialCost * +elem.quanty;
          }
        });
        seriesAllData.push(listTypes);
      });
      const seriesData = typesList.map(type => {
        let data = [];
        seriesAllData?.map(project => {
          Object.keys(project).includes(type)
            ? data.push(project[type])
            : data.push(0);
        });
        return {
          name: this.$t(`worksProfile.${type}`),
          data
        };
      });
      return seriesData;
    },
    formatMoney(val) {
      if (val > 10 ** 6) return `$ ${parseFloat(val / 10 ** 6).toFixed(2)}M`;
      if (val > 10 ** 3) return `$ ${parseFloat(val / 10 ** 3).toFixed(2)}K`;
      return `$ ${parseFloat(val).toFixed(2)}`;
    },
    goToItem(item) {
      this.$router.push(`/work/${item.id}`);
    },
    editItem(item) {
      this.editedIndex = this.works.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.dueDate = null;
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.works.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store.dispatch("deleteDocument", {
        db: `works`,
        doc: this.editedItem.id
      });
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        this.editedItem.dueDate = new Date(this.editedItem.dueDate);
        let payload = {
          db: "works",
          data: this.editedItem,
          doc: this.editedItem.id
        };

        try {
          await this.$store.dispatch("updateDocument", payload);
          this.$dialog.notify.success(
            "Your new work has been updated successfully",
            {
              position: "top-right",
              timeout: 5000
            }
          );
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      } else {
        this.editedItem.date = new Date();
        this.editedItem.inventory = [];
        this.editedItem.dueDate = new Date(this.editedItem.dueDate);
        this.editedItem.disabled = false;

        let payload = {
          db: "works",
          data: this.editedItem
        };

        try {
          await this.$store.dispatch("addDocument", payload);
          this.$dialog.notify.success(
            "Your new work has been created successfully",
            {
              position: "top-right",
              timeout: 5000
            }
          );
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      }

      this.close();
    }
  }
};
</script>
